import { faPencilAlt, faToggleOff, faToggleOn, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { isBrowser, isMobile } from "react-device-detect";
import { Badge, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import BotaoTabela from "../../../../Componentes/BotaoTabela";

export default function Registro({
    dados,
    totalConsumoPesquisaEndereco,
    clicouEditar,

    clicouExcluir
}){

    // retorna opções
    let retornarOpcoes = () => {

        // retorna componentes
        return <>
            <BotaoTabela 
                onClick={clicouEditar}
                icone={faPencilAlt}
            >
                <span>Editar</span>
            </BotaoTabela>
            {
                parseInt(totalConsumoPesquisaEndereco) === 0 && 
                <BotaoTabela
                    onClick={clicouExcluir}
                    icone={faTrashAlt}
                >
                    <span>Excluir</span>
                </BotaoTabela>
            }
        </>
    }

    return <> 

        {/* NAVEGADOR */}
        { isBrowser &&
            <tr
                style={{cursor: 'pointer'}}
                onClick={clicouEditar}
                className={['registro', dados.status].join(' ')}
            >
                <td className={'estreito text-center font-weight-bold destaque'}>
                    <Badge className={['rounded-pill', 'quantidade-empresas'].join(' ')} style={{fontWeight: 800}}>
                        {totalConsumoPesquisaEndereco}
                    </Badge>
                </td>
                <td>
                    <div className="d-flex align-items-center" style={{gap: 3}}>
                        <FontAwesomeIcon style={{fontSize: 12}} color={dados.habilitado !== 'S' ? "#c1c1c1" : "#5c8bff"} icon={dados.habilitado !== 'S' ? faToggleOff : faToggleOn}/>
                        {dados.descricao}
                        <small>({dados.tipo})</small>
                    </div>
                </td>
                <td className={'text-nowrap estreito text-right'}>
                    { retornarOpcoes() }
                </td>
            </tr>
        }

        {/* MOBILE */}
        {isMobile &&
            <Card
                className={'border-0 bg-light mb-2'}
                onClick={clicouEditar}
            >
                <Card.Body className={'p-2'}>
                    <div className={[isBrowser ? 'd-flex' : ''].join(' ')}>
                        <div className={'flex-grow-1'}>
                            <div className="d-flex align-items-center" style={{gap: 3}}>
                                <FontAwesomeIcon style={{fontSize: 12}} color={dados.habilitado !== 'S' ? "#c1c1c1" : "#5c8bff"} icon={dados.habilitado !== 'S' ? faToggleOff : faToggleOn}/>
                                {dados.descricao}
                                <small>({dados.tipo})</small>
                            </div>
                        </div>
                        <div className={'text-right'}>
                            { retornarOpcoes() }
                        </div>
                    </div>
                </Card.Body>
            </Card>
        }
    </>
}